import React from 'react'
import { Select } from '@toctoc/design-system'
import { useAppDispatch, useAppSelector } from 'src/app/hooks'
import { selectFilter, setOrder } from 'src/app/reducers/filters'
import styled from '@emotion/styled'
import { separadorDeMiles } from '@/utils/separadorDeMiles'

const orderByOptions = [
	{ label: 'Más relevantes', value: '1' },
	{ label: 'Precio menor a mayor', value: '2' },
	{ label: 'Precio mayor a menor', value: '3' },
	{ label: 'Recientes', value: '6' },
	{ label: 'Antiguas', value: '7' },
]

interface OrdenarPorV2Props {
	totalPropiedades: number
	tipoOperacionFamilia?: string
	tipoPropiedadFamilia?: string
	isLoading?: boolean
}

export const OrdenarPorV2 = ({
	totalPropiedades,
	tipoOperacionFamilia = '',
	tipoPropiedadFamilia = '',
	isLoading = false,
}: OrdenarPorV2Props) => {
	const dispatch = useAppDispatch()
	const order = useAppSelector(selectFilter).order
	const dataAttr = { 'data-apartado': `${tipoOperacionFamilia} ${tipoPropiedadFamilia}` }

	const handleOrderChange = (event: any) => {
		dispatch(setOrder(event.target.value))
	}

	return (
		<Row>
			{isLoading
				? <CountSkeleton aria-hidden="true" />
				: <CountText>{separadorDeMiles(totalPropiedades)} propiedades encontradas</CountText>
			}
			<SelectWrapper>
				<Select
					label="Ordenar:"
					name="ordenar-por"
					options={orderByOptions}
					onChange={handleOrderChange}
					value={order}
					size="small"
					{...dataAttr}
				/>
			</SelectWrapper>
		</Row>
	)
}

/* ─── Styled Components ─────────────────────────────────────── */

const Row = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 0 8px;
`

const CountText = styled.span`
	font-family: nunito, sans-serif;
	font-size: 14px;
	color: #555;
`

const shimmer = `
	@keyframes shimmer {
		0%   { background-position: -200px 0; }
		100% { background-position: calc(200px + 100%) 0; }
	}
`

const CountSkeleton = styled.span`
	${shimmer}
	display: inline-block;
	width: 180px;
	height: 16px;
	border-radius: 4px;
	background: linear-gradient(90deg, #e8e8e8 25%, #f5f5f5 50%, #e8e8e8 75%);
	background-size: 200px 100%;
	animation: shimmer 1.2s infinite linear;
`

const SelectWrapper = styled.div`
	width: 200px;
`
